/* Balkan — bara de file-ancoră de pe pagina de produs (7 oct. 2026).

   ⚠️ Bara pleacă ASCUNSĂ din server. Șablonul de produs e unul singur pentru
   tot catalogul, deci majoritatea ancorelor lipsesc de pe majoritatea
   paginilor. Aici se scoate orice filă a cărei țintă nu există, iar bara se
   afișează doar dacă rămân cel puțin două — o bară cu o singură filă nu e
   navigație.

   Fila curentă se marchează cu `IntersectionObserver` pe secțiunile-țintă.
   `data-bk-on` (nu `aria-selected`, care nu e valid pe un `<a>`) + `aria-current`
   — aceeași convenție ca la filtrele de colecție, reparată la auditul din
   1 oct. 2026. */
(() => {
  const bara = document.querySelector('[data-bk-pnav]');
  if (!bara) return;

  const file = [...bara.querySelectorAll('[data-bk-pnav-a]')];
  const vii = [];
  file.forEach((a) => {
    const id = (a.getAttribute('href') || '').slice(1);
    const t = id && document.getElementById(id);
    if (t) vii.push({ a, t });
    else a.closest('li')?.remove();
  });
  if (vii.length < 2) return;
  bara.hidden = false;

  /* Derularea e compensată de bara însăși: fără offset, titlul secțiunii intră
     exact sub ea. Înălțimea se citește la fiecare clic — headerul se strânge la
     derulare, deci o valoare memorată ar fi greșită după primul scroll. */
  vii.forEach(({ a, t }) => {
    a.addEventListener('click', (e) => {
      e.preventDefault();
      const h = bara.getBoundingClientRect().height || 0;
      const sus = (document.querySelector('#header-component')?.getBoundingClientRect().height || 0);
      const y = t.getBoundingClientRect().top + window.scrollY - h - sus - 8;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      history.replaceState(null, '', '#' + t.id);
    });
  });

  const marcheaza = (el) => {
    vii.forEach(({ a, t }) => {
      const on = t === el;
      a.toggleAttribute('data-bk-on', on);
      if (on) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
  };

  /* Pragul: secțiunea e „curentă" cât timp partea ei de sus a trecut de bară.
     `rootMargin` de jos la -60% ține marcajul pe secțiunea din care se vede cel
     mai mult, nu pe cea care tocmai a intrat cu un pixel în ecran. */
  const obs = new IntersectionObserver((intrari) => {
    const vizibile = intrari.filter((i) => i.isIntersecting)
      .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
    if (vizibile.length) marcheaza(vizibile[0].target);
  }, { rootMargin: '-120px 0px -60% 0px', threshold: 0 });
  vii.forEach(({ t }) => obs.observe(t));
})();
